import React, { PropsWithChildren } from 'react';

import { formatAddress } from './helpers/address';
import { Props } from './props';

const AddressView: React.FC<PropsWithChildren<Props>> = (props) => {
  const { layout = 'horizontal', data, children, className, style } = props;

  // ================= VIEWS
  const renderContent = () => {
    if (!data) return '-';
    const { formatted, address } = formatAddress(data);
    if (layout === 'horizontal') {
      return formatted;
    }
    const { addressOne, addressTwo, postalCode, city, state, country } =
      address;
    return (
      <>
        <div>{addressOne}</div>
        {addressTwo && <div>{addressTwo}</div>}
        <div>{`${postalCode} ${city}`}</div>
        <div>{`${state} ${country}`}</div>
      </>
    );
  };

  return (
    <div className={className} style={style}>
      {children || renderContent()}
    </div>
  );
};

// ================= EXPORTS
export type AddressProps = Props;
export const Address = AddressView;
export default Address;
